<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-09 13:25:18
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-03-30 11:10:58
 * @Description: 订单明细
-->
<template>
  <div>
    <el-table
      :data="pageList"
      :summary-method="getSummaries"
      show-summary
      border
      style="width: 100%"
    >
      <el-table-column
        type="index"
        width="50"
        align="center"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="orderCode"
        header-align="center"
        align="center"
        label="订单编号"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        prop="orderTotalAmount"
        align="right"
        label="订单金额"
      >
        <template slot-scope="scope">
          {{ scope.row.orderTotalAmount | formatePrice }}
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        prop="currentInvoiceAmount"
        align="right"
        label="本次开票金额"
      >
        <template slot-scope="scope">
          {{ scope.row.currentInvoiceAmount | formatePrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceTypeText"
        header-align="center"
        align="center"
        label="开票类型"
      >
      </el-table-column>
      <el-table-column
        prop="invoiceTaxRate"
        header-align="center"
        align="center"
        label="税率"
      >
        <template slot-scope="scope">
          {{ scope.row.invoiceTaxRate * 100 }}%
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.page"
      :page-sizes="[10, 20, 50, 100, 200]"
      :page-size="page.limit"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="list.length"
    >
    </el-pagination>
  </div>
</template>

<script>
import { formatePrice } from '@/utils/formatePrice'
import tableTotal from '@/utils/tableTotal'
export default {
  filters: {
    formatePrice (val) {
      if (val) {
        return formatePrice(val.toFixed(2))
      }
      return '0.00'
    }
  },
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      page: {
        page: 1, // 第几页
        limit: 20 // 一页多少条
      },
      pageList: [], // 分页数据
      tableTotal: {
        订单金额: '',
        已回款金额: '',
        本次开票金额: '',
        已开票金额: ''
      }
    }
  },
  watch: {
    list () {
      this.setPageList(true)
    }
  },
  methods: {
    setPageList (isReset = false) {
      // 重新赋值的列表从第一页开始
      isReset && (this.page.page = 1)
      const start = (this.page.page - 1) * this.page.limit
      const end = this.page.page * this.page.limit
      this.pageList = this.list.slice(start, end)
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.page.page = val
      // 刷新列表数据
      this.setPageList()
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.page.page = 1
      this.page.limit = val
      // 刷新列表数据
      this.setPageList()
      scrollTo(0, 500)
    },
    // 表格底部合计
    getSummaries (param) {
      return tableTotal(param, this.tableTotal)
    }
  }
}
</script>

<style lang="scss" scoped></style>
